// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_m1-1";
export var rowFirst = "_m1-3";
export var rowLast = "_m1-5";
export var rowMiddle = "_m1-4";
export var ticketListScroll = "_m1-2";
export var ticketStack = "_m1-0";